import { useApolloClient } from '@apollo/react-hooks'
import { mapWorkerToUserPersona, Worker } from 'model'
import { IPersonaProps } from 'office-ui-fabric-react'
import {
  WorkerSuggestionsDocument,
  WorkerSuggestionsQuery,
} from './useWorkerSuggestions.generated'

export const defaultMapWorkerToWorkerPersona = (worker: Worker) => ({
  userId: worker._id,
  text: `${worker.lastName}, ${worker.firstName}`,
  secondaryText: worker.department,
})

export type WorkerToWorkerPersonaMapper = (worker: Worker) => IPersonaProps

export const useWorkerSuggestions = () => {
  const client = useApolloClient()

  const suggestWorkers = async (
    filter: string,
    selectedItems?: IPersonaProps[]
  ) => {
    if (filter.length < 2) {
      return []
    }

    const result = await client.query<WorkerSuggestionsQuery>({
      query: WorkerSuggestionsDocument,
      fetchResults: true,
      variables: { filter, avatarSize: 96 },
    })

    const workers: Worker[] =
      result.data && result.data.workers
        ? (result.data.workers as Worker[])
        : []

    filter = filter.toLocaleLowerCase()

    const exactMatches: IPersonaProps[] = []
    const filtered = workers
      .filter((w) => w.inactive !== true)
      .filter(
        (w) =>
          w!.department!.toLocaleLowerCase().indexOf(filter) !== -1 ||
          w!.lastName.toLocaleLowerCase().indexOf(filter) !== -1 ||
          w!.firstName.toLocaleLowerCase().indexOf(filter) !== -1
      )
      .filter((w) => Boolean(w.lastName))
      .map((worker) => {
        if (
          worker.lastName.toLocaleLowerCase() === filter ||
          worker.firstName.toLocaleLowerCase() === filter
        ) {
          exactMatches.push(mapWorkerToUserPersona(worker))
        }
        return mapWorkerToUserPersona(worker)
      })

    return filter.length === 2 ? exactMatches : filtered
  }

  return {
    suggestWorkers,
    suggestAllWorkers: (selectedItems?: IPersonaProps[]) =>
      suggestWorkers('', selectedItems),
  }
}
